import RadioGroup from "@/components/forms/radio-group";
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { ShieldAlert } from 'lucide-react';
import type { DeclarationStepProps } from '@/pages/accident/declaration-sinistre/types';

const DeclarationVol = (props: DeclarationStepProps) => {
    const { values, setValue } = props;

    return (
        <Card className="mt-6">
            <CardHeader className="pb-6 border-b">
                <CardTitle className="text-lg flex items-center gap-2">
                    <ShieldAlert className="w-5 h-5 text-primary" />
                    Dites-nous en plus...
                </CardTitle>
            </CardHeader>
            <CardContent className="pt-6 space-y-8">
                <RadioGroup label="Votre véhicule était-il dans un garage ?" name="vehiculeIsInGarage" setValue={setValue} options={[{ value: "T", label: "Oui" }, { value: "F", label: "Non" }]} value={values.vehiculeIsInGarage} />
                <RadioGroup label="Votre véhicule était-il gravé ?" name="vehiculeIsMark" setValue={setValue} options={[{ value: "T", label: "Oui" }, { value: "F", label: "Non" }]} value={values.vehiculeIsMark} />
                <RadioGroup label="Votre véhicule était-il attaché avec un antivol au moment du vol ?" name="vehiculeIsAttached" setValue={setValue} options={[{ value: "T", label: "Oui" }, { value: "F", label: "Non" }]} value={values.vehiculeIsAttached} />
                <RadioGroup
                    label={`Avez-vous un procès-verbal de ${values.catsinorigin === "10.0" ? "vol" : "tentative de vol"} ?`}
                    name="hasPV"
                    setValue={setValue}
                    options={[{ value: "T", label: "Oui" }, { value: "F", label: "Non" }]}
                    value={values.hasPV}
                />
                <RadioGroup
                    label={`Avez-vous été violenté ou agressé lors du ${values.catsinorigin === "10.0" ? "vol" : "tentative de vol"} ?`}
                    name="hasAggression"
                    setValue={setValue}
                    options={[{ value: "T", label: "Oui" }, { value: "F", label: "Non" }]}
                    value={values.hasAggression}
                />
            </CardContent>
        </Card>
    );
};

export default DeclarationVol;
